import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Box,
  IconContainer,
  P,
  H4,
  Button,
  ScreenReaderText,
} from '@allied-solutions/affinity'
import {
  Search,
  SuccessSolid,
  Close03,
  ErrorSolid,
  Upload01,
  QuestionCircle,
  ClockSolid,
  WarningSolid,
  Shield02,
} from '@allied-solutions/affinity-react-icons/standard'

const STATUS_ICON_BY_NAME = {
  ClockSolid,
  WarningSolid,
  Search,
  Close03,
  ErrorSolid,
  Shield02,
  SuccessSolid,
}

const resolveStatusIcon = icon =>
  typeof icon === 'string' ? STATUS_ICON_BY_NAME[icon] : icon

const replaceStatusPlaceholders = (text, { errorCount } = {}) => {
  if (text == null || typeof text !== 'string') return text
  return text.replaceAll('{{errorCount}}', String(errorCount ?? 0))
}

const StyledStatusCard = styled(Box)`
  border-width: 1px;
  border-style: solid;
  border-radius: ${props => props.theme.radii.md};
`

export const DashboardTileStatusCardDetailed = ({
  accountStatusDetails,
  errorCount,
  openUploadModal,
  referenceId,
  onOpenHelp,
}) => {
  if (!accountStatusDetails) return null

  const cardMessage = replaceStatusPlaceholders(
    accountStatusDetails.cardMessage,
    { errorCount }
  )

  return (
    <StyledStatusCard
      p="2xl"
      bg={accountStatusDetails.bg}
      borderColor={accountStatusDetails.borderColor}
    >
      <Box
        display="flex"
        gap="xl"
        flexDirection={['column', 'column', 'column', 'row']}
        alignItems={['center', 'center', 'center', 'flex-start']}
      >
        <IconContainer
          icon={resolveStatusIcon(accountStatusDetails.icon)}
          color={accountStatusDetails.iconColor}
          solid
        />
        <Box
          display="flex"
          alignItems={['center', 'center', 'center', 'flex-start']}
          flexDirection="column"
        >
          <H4 typeStyle="labelLarge.bold" mb={0}>
            {accountStatusDetails.cardHeader}
          </H4>
          <P
            typeStyle="bodyMedium"
            mb={0}
            textAlign={['center', 'center', 'center', 'left']}
          >
            {cardMessage}
          </P>
          <Box display="flex" alignItems="center" gap="2xl">
            <Button
              variant={accountStatusDetails.buttonVariant}
              id="update-insurance-button"
              outlined={!accountStatusDetails?.buttonVariant}
              mt="2xl"
              icon={Upload01}
              onClick={() => openUploadModal?.(referenceId)}
            >
              Update Insurance
            </Button>
            <Button
              type="button"
              icon={QuestionCircle}
              mt="2xl"
              onClick={() => onOpenHelp?.()}
              aria-label="Get support / open help menu"
            >
              <ScreenReaderText>Get Support / Open Help Menu</ScreenReaderText>
            </Button>
          </Box>
        </Box>
      </Box>
    </StyledStatusCard>
  )
}

DashboardTileStatusCardDetailed.propTypes = {
  openUploadModal: PropTypes.func,
  referenceId: PropTypes.string,
  onOpenHelp: PropTypes.func,
  accountStatusDetails: PropTypes.object,
  errorCount: PropTypes.number,
}
